module.exports = __webpack_public_path__ + "img/image 177.02371c96.svg";